<div class="application-form__section" *ngIf="showSection">
  <div class="application-form__section-title">
    <h3>{{ sectionName }}</h3>
    <div *ngIf="isQuestionLocked" class="application-form__section-sub-heading">
      <label><span class="question-lock--required">*</span> Indicates required field</label>
    </div>
  </div>
  <ng-container *ngFor="let question of appSection.children">
    <div
      class="application-form__question-container"
      [id]="question.prop ? question.id + '_' + question.prop : question.id"
      [ngClass]="question.styleClass"
    >
      <ng-container *ngIf="question.isShown()">
        <dynamic-component
          [componentData]="{ question: question }"
          [wrapperClass]="
            question.controlType === 'label-basic' ? 'application-form__label' : 'application-form__question'
          "
        ></dynamic-component>
      </ng-container>
      <div class="payment-alert-container">
        <cpds-alert *ngIf="shouldDisplayPaymentAlert(question)" intent="danger" class="paymentInfo-app-alert">
          <span>{{ paymentInfoError }} </span>
        </cpds-alert>
      </div>
      <ng-container *ngFor="let childQuestion of question.children">
        <ng-container *ngIf="childQuestion.isShown()">
          <div class="application-form__traverse-container">
            <application-form-question-traverse [childQuestion]="childQuestion"></application-form-question-traverse>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
</div>
